















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ProgressDetails',

  computed: {
    ...mapGetters('map', [
      'isProcessDone',
      'getCurrentIteration',
      'getIterations',
    ]),

    currentProgress() {
      console.log(Math.round((this.getCurrentIteration / this.getIterations) * 100));
      return Math.round((this.getCurrentIteration / this.getIterations) * 100);
    },
  },
});
